<template>
  <el-dialog
    :close-on-click-modal="false"
    :before-close="handleClose"
    :visible="visible"
    title="打印毕业论文考核单"
    width="800px"
  >
    <div class="dialogMain" v-if="data">
      <div id="printCardId">
        <center>
          <div style="width: 720px">
            <div
              style="
                text-align: center;
                font-size: 22px;
                font-family: '宋体';
                font-weight: bold;
                margin: 20px 0;
              "
            >
              四川省高等教育自学考试{{data.schName}}毕业考核通知单
            </div>
            <div
              style="
                text-align: left;
                font-size: 14px;
                padding-left: 10px;
                margin-bottom: 4px;
              "
            >
              <span style="font-family: '楷体_GB2312', '楷体'">报名单位:</span
              ><span style="padding-left: 10px" v-if="data.helpCode"
                >{{`${data.helpCode}-${data.helpName}`}}</span
              >
            </div>
            <table
              align="center"
              class="baseInfoTbl"
              CELLPADDING="0"
              CELLSPACING="0"
            >
              <tr>
                <td class="td1" >姓名</td>
                <td class="td2" style="width: 80px;">{{data.name}}</td>
                <td class="td1">身份证号</td>
                <td class="td2" style="width: 286px;">
                  <div class="u_no_div" v-if="data&&data.idCardNumber&&data.idCardNumber.length>0">
                    <template v-for="(e,i) in data.idCardNumber">
                      <span  :key="i">{{e}}</span>
                    </template>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="td1" >专业代码</td>
                <td>{{ data.specialtyCode}}</td>
                <td class="td1">专业名称</td>
                <td>{{ data.specialtyName}}</td>
              </tr>
              <tr>
                <td class="td1">
                  <span style="font-size: 13px">主考学校代码及名称</span>
                </td>
                <td colspan="3" v-if="data.schoolCode">{{`${data.schoolCode}-${data.schName}`}}</td>
              </tr>
              <tr>
                <td class="td1">考期</td>
                <td colspan="3">
                  <div class="div1" v-if="data.thesisBatchName">{{data.thesisBatchName}}</div>
                </td>
              </tr>
              <tr>
                <td class="td1">考核时间</td>
               <!-- <td colspan="3"><div class="div1">{{examDate || ''}}</div></td> -->
                <td colspan="3"><div class="div1"><template v-if="thesisDbGroup&&thesisDbGroup.startTime">{{thesisDbGroup.startTime+" 至 "+thesisDbGroup.endTime}}</template></div></td>
              </tr>
              <tr>
                <td colspan="4" class="td1">报名课程</td>
              </tr>
              <tr>
                <td class="td1">课程代码</td>
                <td class="td1" colspan="3">课程名称</td>
              </tr>
              <tr>
                <td>{{data.courseCode}}</td>
                <td colspan="3">{{data.courseName}}</td>
              </tr>
              <tr>
                <td>分组信息</td>
                <td colspan="3"><span v-if="thesisDbGroup.sortNo">第{{ thesisDbGroup.sortNo }}组{{ thesisDbGroup.groupNo }}号</span></td>
              </tr>
              <tr v-if="!thesisDbGroup.examWay">
                <td>答辩地址</td>
                <td colspan="3">{{thesisDbGroup.examAddr}}</td>
              </tr>
            </table>
            <div
              style="
                margin-top: 4px;
                margin-bottom: 10px;
                font-size: 15px;
                font-family: '楷体', '楷体_GB2312';
                text-align: left;
              "
            >
              注：此表一份，上交即可。
            </div>
            <table style="width: 100%; font-size: 15px">
              <tr>
                <td style="text-align: left; width: 50%; height: 40px">
                  经办人签名：
                </td>
                <td>考生签名：</td>
              </tr>
              <tr>
                <td style="text-align: left; padding-left: 30px">（盖章）</td>
                <td style="padding-left: 75px">
                  年<span style="padding-left: 20px">月</span
                  ><span style="padding-left: 20px">日</span>
                </td>
              </tr>
              <tr>
                <td style="text-align: left; padding-left: 30px" colspan="2">
                  <p>&nbsp;</p>
                  <p>&nbsp;</p>
                  <p>&nbsp;</p>
                </td>
              </tr>

              <tr>
                <td
                  style="text-align: left; width: 50%; height: 40px"
                  colspan="2"
                >
                  <p style="margin: 0">考生须知：</p>
                  <p style="margin: 0">（一）考试程序</p>
                  <p style="margin: 0">
                    考生提前熟悉了解考试流程及实操要求，进行相关实践考核环节；
                  </p>
                  <p style="margin: 0">（二）考生必带</p>
                  <p style="margin: 0">
                    1.考生应打印实践报告、已审核通过论文纸质版一份
                  </p>
                  <p style="margin: 0">2.考生应下载打印实践考核通知单</p>
                  <p style="margin: 0">
                    <!-- （打印平台：https://{{data.schoolCode}}.whxunw.com/exam/login.thtml） -->
                  </p>
                  <p style="margin: 0">（三）注意事项</p>
                  <p style="margin: 0">
                    学生携带纸质考核通知单、纸质论文、实践报告→考核点签到处签字→候考区排队→等待工作人员通知→有秩序入场考核
                  </p>
                </td>
              </tr>
            </table>
          </div>
        </center>
      </div>
    </div>
    <div slot="footer">
      <el-button @click="handleClose" size="mini">取消</el-button>
      <el-button v-print="{ id: '#printCardId',popTitle:'' }" size="mini" type="primary"
        >打印</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "Detail",
  props: {},
  data() {
    return {
      title: "",
      visible: false,
      titleName: "",
      tableData: [],
      d: {},
      data: {},
      examDate:"",
      thesisDbGroup:{}
    };
  },
  created() {},
  methods: {
    handleClose() {
      this.visible = false;
      this.data = {};
    },
    open(thesisBatchId) {
      this.$http.post("/student/thesis2/toPrintBmb", {thesisBatchId: thesisBatchId},{isQs:1}).then(res => {
        this.data = res.data
        this.examDate = res.examDate
        this.thesisDbGroup = res.data.thesisDbGroup||{}
        this.visible = true;
      })
    },
    submit() {},
  },
};
</script>

<style scoped lang="scss">
@media print {
  .hidden-print {
    display: none !important;
  }
}

body {
  margin: 10;
  padding: 0em;
  overflow: auto;
  font-size: 12px;
}

.baseInfoTbl {
  border-collapse: collapse;
  border: none;
  width: 100%;
  margin-bottom: 10px;
}
.baseInfoTbl td,
th {
  border: solid #000 1px;
  height: 30px;
  vertical-align: middle;
  text-align: center;
}

.td1 {
  width: 131px;
  font-family: 黑体;
  font-size: 15px;
}

.td2 {
  width: 230px;
  font-family: 宋体;
  font-size: 14px;
}

.u_no_div span {
  width: 18px;
  height: 30px;
  float: left;
  border-right: solid #000 1px;
  line-height: 30px;
}
.u_no_div span:last-child {
  border-right-width: 0;
}

.u_certino_div span {
  width: 31.66px;
  height: 30px;
  float: left;
  border-right: solid #000 1px;
  line-height: 30px;
}
.u_certino_div span:last-child {
  border-right-width: 0;
}

.sch_field {
  padding-left: 6px;
  padding-right: 6px;
  border-right: solid #000 1px;
  line-height: 30px;
  float: left;
  font-family: 黑体;
  font-size: 15px;
}
.sch_value {
  padding-left: 6px;
  line-height: 30px;
  float: left;
}
</style>
